import cls from 'classnames';
import { useState, useCallback, useRef, useEffect } from 'react';

import { IToolData, IBottomLink } from '../../../../../data/tools/types';
import BottomLinks from '../BottomLinks';
import NavMenuItem from '../NavMenuItem';
import DropdownSubmenu from '../DropdownSubmenu';

import useStyles from './styles';

type SublinkProps = {
  id: string;
  links: IToolData[];
  iconColor: string;
  fillColor: string;
  bottomLinks: IBottomLink[];
};

function NavDropdown({ id, links, iconColor, fillColor, bottomLinks }: SublinkProps) {
  const classes = useStyles();
  const [visibleSubmenu, setVisibleSubmenu] = useState('');
  const setVisible = useCallback((menu: string) => {
    setVisibleSubmenu(menu);
  }, []);
  const container = useRef<HTMLDivElement>(null);
  const [itermediateLeft, setItermediateLeft] = useState(0);
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (!container.current || !visibleSubmenu) {
      return;
    }
    const { x, width } = container.current.getBoundingClientRect();
    if (x + width > document.body.clientWidth) {
      setItermediateLeft(document.body.clientWidth - (x + width));
    }
  }, [visibleSubmenu]);

  useEffect(() => {
    if (left > itermediateLeft) {
      setLeft(itermediateLeft);
    }
  }, [itermediateLeft]);

  return (
    <div
      className={cls(classes.root, 'NavDropdown')}
      onMouseLeave={() => {
        setVisible('');
        setLeft(0);
        setItermediateLeft(0);
      }}
      ref={container}
      style={{ left }}
    >
      <div className={cls(classes.left, `NavDropdown${id}`)}>
        <ul className={classes.items}>
          {links.map(
            ({ name, href, id: key, icon, subCategories, openInNewTab, isNew, iconRound }) => (
              <li
                key={key}
                className={cls(classes.item, key === visibleSubmenu && classes.itemSelected)}
              >
                <NavMenuItem
                  textClassName={classes.menuItemText}
                  id={key}
                  name={name}
                  href={href}
                  icon={icon}
                  subCategories={subCategories}
                  openInNewTab={openInNewTab}
                  iconColor={iconColor}
                  fillColor={fillColor}
                  isNew={isNew}
                  setVisible={setVisible}
                  iconRound={iconRound}
                />
              </li>
            ),
          )}
        </ul>
        <BottomLinks links={bottomLinks} />
      </div>

      <DropdownSubmenu links={links} visibleSubmenu={visibleSubmenu} />
    </div>
  );
}

export default NavDropdown;
